/* eslint-disable no-undef */
import Grid from '@mui/material/Grid';
import { styled } from '@mui/system';
import i18next, { changeLanguage } from 'i18next';
import React, { useState } from 'react';
import { useTranslation, withTranslation } from 'react-i18next';
import '../../utils/common.scss';
import LanguageIcon from '@mui/icons-material/Language';
import MenuIcon from '@mui/icons-material/Menu';
import SETTINGS from './../../utils/constants';
import { ButtonBase, Menu, MenuItem } from '@mui/material';
import LogoComponent from './logo.jsx';
import PropTypes from 'prop-types'
import { ReactComponent as Logo } from '../../misc/logoForHeader.svg';

const HeadOption = styled(ButtonBase)(({theme})=>({
  color: SETTINGS.DEEP_COLOR,
  fontSize: 19,
  fontWeight: 400,
  padding: '10px',
  cursor: 'pointer',
  [theme.breakpoints.up('sm')]: {
    fontSize: 16
  },
  [theme.breakpoints.up('md')]: {
    fontSize: 18
  },
}))

const Header = (props) => {
  const {t} = useTranslation();
  const [anchorEl, setAnchorEl] = useState();
  const menuOpen = Boolean(anchorEl)
  const {clinicInfoRef, priceInfoRef, contactRef} = props

  const moveToClinicInfo=()=>{
    clinicInfoRef.current?.scrollIntoView({behavior:'smooth'})
  }

  const moveToPriceInfo=()=>{
    priceInfoRef.current?.scrollIntoView({behavior:'smooth'})
  }

  const moveToContact=()=>{
    contactRef.current?.scrollIntoView({behavior:'smooth'})
  }

  const onChangeLanguage=()=>{
    if(i18next.language === 'en') {
      changeLanguage('cn')
    }else{
      changeLanguage('en')
    }
  }

  const handleMenuClick=(e)=>{
    setAnchorEl(e.currentTarget)
  }

  const handleMenuClose=()=>{
    setAnchorEl(null) 
  }

  return (
    <div>
      <Grid container direction="row" sx={{backgroundColor: SETTINGS.PRIMARY_COLOR, boxShadow: 3, zIndex: 100, position: 'fixed'}} display={{xs:'none', sm:'flex'}}>
        <Grid item md={1.5} xs={0}/>
        <Grid item md={9} sm={10}>
          <Grid container direction="row" spacing={2} justifyContent="center">
            <Grid item sm={2} className="center-item" sx={{maxHeight: '10vh'}}>
              <Logo fill={SETTINGS.LOGO_COLOR} style={{height: 'auto', width: 'auto', maxHeight: '100%', maxWidth: '100%'}}/>
            </Grid>
            <Grid item sm={2} className="center-item">
              <HeadOption sx={{fontWeight: 700}}>
                {t('header.name')}
              </HeadOption>
            </Grid>
            <Grid item sm={8} className="center-item">
              <Grid container justifyContent="center">
                <Grid item sm={3} className="center-item">
                  <HeadOption onClick={moveToClinicInfo}>
                    {t('header.option1')}
                  </HeadOption>
                </Grid>
                <Grid item sm={3} className="center-item">
                  <HeadOption onClick={moveToPriceInfo}>
                    {t('header.option2')}
                  </HeadOption>
                </Grid>
                <Grid item sm={3} className="center-item">
                  <HeadOption onClick={moveToContact}>
                    {t('header.option3')}
                  </HeadOption>
                </Grid>
                <Grid item sm={3} className="center-item" sx={{color: SETTINGS.DEEP_COLOR}} onClick={onChangeLanguage}>
                  <ButtonBase sx={{padding:'3px'}}>
                    <LanguageIcon fontSize={'large'} />
                    {t('header.languageSwitch')}
                  </ButtonBase>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid item sm={1.5} xs={0} />
      </Grid>

      <Grid container direction="row" sx={{backgroundColor: SETTINGS.PRIMARY_COLOR, boxShadow: 3, zIndex: 100, position: 'fixed'}} display={{xs:'flex', sm: 'none'}}>
        <Grid item xs={2}/>
        <Grid item xs={8} className="center-item" sx={{maxHeight: '15vh'}}>
          <LogoComponent />
        </Grid>
        <Grid item xs={2} className="center-item">
          <ButtonBase sx={{color: SETTINGS.DEEP_COLOR}}>
            <MenuIcon fontSize={'large'} onClick={(event)=>handleMenuClick(event)} />
            <Menu
              id="basic-menu"
              anchorEl={anchorEl}
              open={menuOpen}
              onClose={handleMenuClose}
              MenuListProps={{
                'aria-labelledby': 'basic-button',
              }}
            >
              <MenuItem onClick={handleMenuClose}>
                <ButtonBase onClick={()=>{window.scrollTo(0, document.documentElement.scrollHeight*0.07)}}>
                  {t('header.option1')}
                </ButtonBase>
              </MenuItem>
              <MenuItem onClick={handleMenuClose}>
                <ButtonBase onClick={()=>{window.scrollTo(0, document.documentElement.scrollHeight*0.85)}}>
                  {t('header.option2')}
                </ButtonBase>
              </MenuItem>
              <MenuItem onClick={handleMenuClose}>
                <ButtonBase onClick={()=>{window.scrollTo(0, document.documentElement.scrollHeight*0.95)}}>
                  {t('header.option3')}
                </ButtonBase>
              </MenuItem>
              <MenuItem onClick={handleMenuClose}>
                <ButtonBase onClick={onChangeLanguage}>
                  {t('header.languageSwitch')}
                </ButtonBase>
              </MenuItem>
            </Menu>
          </ButtonBase>
        </Grid >
      </Grid>
    </div>
  )
}

Header.propTypes = {
  clinicInfoRef: PropTypes.any,
  priceInfoRef: PropTypes.any,
  contactRef: PropTypes.any
}

export default withTranslation()(Header)
